<template>
  <Layout>
    <Title :height="28" imgUrl="url('@/assets/img/bg-serv-white-title.svg')">
      <img src="@/assets/img/assinador-title-logo.svg" class="h-44 w-auto" alt="Assinador Service logo" />
    </Title>
    <About
      title="Assinaturas deveriam ser a parte simples do seu trabalho"
      text="E com o Assinador Service elas serão! Gerencie suas assinaturas digitas com mais segurança e tornando seu trabalho mais ágil."
      service="assinador"
    />
    <Benefits :solutionId="10" />
    <PlansComparison :solution-id="10" />
    <Solutions title="Mais soluções" />
    <Depoimentos title="Depoimentos" />
    <Faq title="Perguntas Frequentes" :questions="faqStore.questions" />
  </Layout>
</template>

<script lang="ts" setup>
import Layout from '@/components/BaseLayout/Layout.vue';
import Title from '@/components/Title/Title.vue';
import Benefits from '@/components/Benefits/Benefits.vue';
import PlansComparison from '@/components/Plans/PlansComparison.vue';
import Solutions from '@/components/Solutions/Solutions.vue';
import Depoimentos from '@/components/Depoimentos/Depoimentos.vue';
import Faq from '@/components/Faq/Faq.vue';
import { useFaqStore } from '@/store/faqStore';
import About from '@/components/About/About.vue';

const faqStore = useFaqStore();
</script>
